import { Component, OnInit, Input, SimpleChanges, ChangeDetectorRef, ViewChild } from '@angular/core';
import { ContextMenuComponent } from 'ngx-contextmenu';
import * as _ from 'lodash'
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { MatDialog } from '@angular/material';
import { JobDetailsComponent } from '../job-details/job-details.component';
import { UtilityService } from '../../../services/utility.service';

@Component({
  selector: 'app-instructor-week',
  templateUrl: './instructor-week.component.html',
  styleUrls: ['./instructor-week.component.scss']
})
export class InstructorWeekComponent implements OnInit {

  jobs = [];

  @Input('weekRange') weekRange;
  @Input('instructor') instructor;
  @ViewChild(ContextMenuComponent, { static: false }) public basicMenu: ContextMenuComponent;

  public contextMenuActions = [];
  tempArray = [];
  tempJobTitle = [];
  user: any;
  isDisable: boolean = false;
  constructor(
    private changeDetector: ChangeDetectorRef,
    public router: Router,
    public dialog: MatDialog,
    public _utilityService: UtilityService
  ) {
    this.user = JSON.parse(localStorage.getItem('userRoles'))
  }

  ngOnInit() {
    this.changeDetector.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges): void {
    // console.log('changes in instructor week', changes)
    if (changes && changes.instructor) {
      this.instructor = changes.instructor.currentValue
      // console.log('this.instructor============>>>>>>>>', this.instructor)
      this.fillDays()
    }
  }

  fillDays() {
    // console.log("week range data", this.weekRange);

    if (this.weekRange && this.weekRange.length) {
      this.fillAddJobContextMenu(this.weekRange)
      // this.weekRange.forEach(weekDate=>{
      this.instructor.dates.forEach(date => {
        if (this.weekRange == date.date) {
          console.log("THIS IS THE JOB LIST TO BE DISPLAY", date, this.weekRange, this.instructor.staffName, this.instructor.dates);
          this.jobs.push(date)
          this.jobs.forEach(singleJob => {
            if (this.tempJobTitle.length) {
              let index = _.findIndex(this.tempJobTitle, function (o) {
                // console.log("o.jobId", o.jobId, "singleJob.jobId", singleJob.jobId)
                return o.jobId == singleJob.jobId
              })
              if (index == -1) {
                this.tempJobTitle.push(singleJob)
                this.fillJobTitleContextMenu(singleJob)
              }
            } else {
              this.tempJobTitle.push(singleJob)
              this.fillJobTitleContextMenu(singleJob)
            }
          })
          console.log('this.jobs--------', this.tempJobTitle)
          // console.log('this.contextMenuActions--------', this.contextMenuActions)
        } else {
          if (this.tempArray.length) {
            let temp = this.instructor
            let index = _.findIndex(this.tempArray, function (o) {
              // console.log("o.staffId", o.staffId, "this.instructor.staffId", temp.staffId)
              return o.staffId == temp.staffId
            })
            if (index != -1) {
              this.tempArray.push(this.instructor)
            }
          } else {
            this.tempArray.push(this.instructor)
          }
          if (this.tempArray.length == 1 && this.contextMenuActions.length == 0) {
            this.fillAddJobContextMenu(date)
          }
          // console.log("this.instructor.dates")
          //
        }
      })



      // if(this.instructor.dates.length == 0){
      //   console.log("in if when no dates", this.instructor)
      //   this.fillAddJobContextMenu(this.instructor, this.weekRange,null)
      // }
      this.changeDetector.detectChanges();
    }
  }


  fillAddJobContextMenu(date) {


    if (this.instructor.role.length == 0 && (this.user.isAdmin || this.user.isManager)) {
      let obj = {
        html: () => `Please add User Role`,
        click: (item) => item,
        enabled: () => false,
        visible: () => 'type1',
      }
      this.contextMenuActions.push(obj)
    } else if ((this.instructor.role.includes('operative')) && (this.user.isAdmin || this.user.isManager)) {
      let jobObj1 = {
        jobType: 'labour',
        selectedDate: date,
        instructors: this.instructor
      }
      let obj1 = {
        html: () => `Add Labour Job`,
        click: () => jobObj1,
        enabled: () => true,
        visible: () => 'type1',
      }
      this.contextMenuActions.push(obj1)
    }
    // {
    if ((this.instructor.role.includes('trainer') || this.instructor.role.includes('IQA')) && this.user.isAdmin) {
      let jobObj1 = {
        jobType: 'trainer',
        selectedDate: date,
        instructors: this.instructor
      }
      let obj1 = {
        html: () => `Add Training Job`,
        click: () => jobObj1,
        enabled: () => true,
        visible: () => 'type1',
      }
      this.contextMenuActions.push(obj1)
    }

    if (this.instructor.role.includes('mp') && this.user.isAdmin) {
      let jobObj = {
        jobType: 'mp',
        selectedDate: date,
        instructors: this.instructor
      }
      let obj = {
        html: () => `Add Medical Practitioners Job`,
        click: () => jobObj,
        enabled: () => true,
        visible: () => 'type1',
      }
      this.contextMenuActions.push(obj)
    }
    // }

    // console.log("single staff data", this.instructor, this.isDisable);

  }

  fillJobTitleContextMenu(singleJob) {
    if (singleJob) {
      let obj = {
        html: () => singleJob.title,
        click: () => singleJob,
        enabled: () => true,
        visible: () => 'type1',
      }
      this.contextMenuActions.push(obj)
      // console.log("this.contextMenuActions", this.contextMenuActions)
    }
    // console.log("this.contextMenuActions", this.contextMenuActions)
  }

  showJobDetails(job) {
    console.log("job details ", job);
    if (job && job.selectedDate) {

      let dateString = job.selectedDate; // Oct 23

      let dateParts = dateString.split("/");

      // month is 0-based, that's why we need dataParts[1] - 1
      console.log(" Yash Check this dateParts", dateParts)
      let dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
      console.log(" Yash Check this dateObject", dateObject)


      let obj = {
        date: dateObject,
        selectedUser: job.instructors.staffId,
        role: job.instructors.role
      }
      if (job.jobType == 'trainer') {
        this.router.navigateByUrl('/add-job', { state: { data: obj } });
      }
      if (job.jobType == 'mp') {
        this.router.navigateByUrl('/addmpjob', { state: { data: obj } });
      }
      if (job.jobType == 'labour') {
        this.router.navigateByUrl('/labour-job/create');
      }

    } else {
      console.log("call this else part");

      // Here is opne modal to diplsay details
      let data
      if (job.jobType == 'trainer' || job.jobType == 'mp') {
        let jobObj = {
          title: job.title,
          color: job.color,
          client: job.clientDetails,
          instructors: job.instructors ? job.instructors : job.mps,
          location: job.location,
          course: job.course,
          startingDate: job.startingDate,
          singleJobDate: job.singleJobDate,
          totalDays: job.totalDays,
          isArchive: job.isArchive,
          jobType: job.jobType,
          clients: job.clients,
          startTime: job.startTime,
          roomNumber: job.roomNumber,
          jobLocation: job.jobLocation
        }
        data = jobObj
      } else if (job.jobType == 'labour') {
        console.log("THIS IS FOR LABOUR JOB DATA", job);
        let obj = {
          title: job.title,
          color: job.color,
          locationDetails: job.locationDetails,
          jobType: job.jobType,
          operatives: job.operatives,
          startDate: job.startDate,
          endDate: job.endDate,
          startTime: job.startTime,
          endTime: job.endTime,
          totalDays: job.totalDays,
          plannedhours: job.plannedhours,
          clients: job.clients
        }
        data = obj
      }

      const dialogRef = this._utilityService.commonDialogBoxOpen(JobDetailsComponent, data, { width: '1000px', height: '1000px' })
        .afterClosed().subscribe((data) => {

        })

      // this.openDialog(JobDetailsComponent, data).subscribe(confirm => {
      //   console.log(confirm);
      // });
    }

  }

  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, { data, width: '100vw', height: '100vh' });
    return dialogRef.afterClosed();
  }

}
